import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route } from "react-router";
import FindFactura from './views/FindFactura';
import FacturaShow from './views/FacturaShow/FacturaShow';
import reportWebVitals from './reportWebVitals';
import './index.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  //  <React.StrictMode>
    <BrowserRouter>
    <Routes>
      <Route index path="" element={<FindFactura />} />
      <Route index path="/:hash" element={<FacturaShow />} />
    </Routes>
  </BrowserRouter>
  //  </React.StrictMode> 
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
